import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 753E83CB-F6D2-4162-B3B4-6D2B8E0DC642
 * name valve-closed
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/valve-closed.svg
 * tags
 * - Home Automation 
 */
export const ValveClosedIcon = createSvgIcon(<><path d="M22 2V22H20V13H14.82A3 3 0 0 1 9.18 13H4V22H2V2H4V11H9.18A3 3 0 0 1 14.82 11H20V2Z" /></>, 'ValveClosedIcon');
export default ValveClosedIcon